export const COOKIE_LOCAL_STORAGE_ID =
  "cookie_banner_8d38dfec-62d0-40e3-b739-db09a7663929";
